import { useLoaderData } from "react-router";
import React from "react";
import TwoColumnLayout from "layout/TwoColumnLayout";
import { isPanelVisible } from "utilities/panelUtils";
import NotesPanel from "note/list/app";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import AreYouSureModal from "components/modals/AreYouSureModal";
import { FromWebformSection } from "./FromWebformSection";

export const ShowFromWebfromApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ShowFromWebformFrontModel>();
  const [displayDeleteModal, setDisplayDeleteModal] = React.useState(false);

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <FromWebformSection
        venue={viewModel.venue}
        venueContact={viewModel.venueContact}
        similarVenueCompanyCount={viewModel.similarVenueCompanyCount}
        similarVenueContactCount={viewModel.similarVenueContactCount}
        promoterCompany={viewModel.promoterCompany}
        promoterContact={viewModel.promoterContact}
        similarPromoterCompanyCount={viewModel.similarPromoterCompanyCount}
        similarPromoterContactCount={viewModel.similarPromoterContactCount}
        show={viewModel.show}
        webform={viewModel.webform}
        productsByParent={viewModel.productsByParent}
        freeFieldCategories={viewModel.freeFieldCategories}
      />

      {isPanelVisible(viewModel.linkedNotePanelConfig) && <NotesPanel
        config={viewModel.linkedNotePanelConfig}
        mainArea="show"
      />}

      {displayDeleteModal && <AreYouSureModal
        title={RESX.GeneralLabels.Delete}
        textContent={RESX.GeneralWarnings.DeleteSure}
        onClose={() => { setDisplayDeleteModal(false); }}
        onYes={async () => window.CoreApi.Show.Delete(viewModel.show.showId).then(() => window.location.href = viewModel.listUrl)}
        yesButtonLabel={RESX.GeneralLabels.Delete}
        yesButtonColor="red"
      />}
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <GeneralOptionsPanel
        data={viewModel.optionsPanel}
        links={[
          { text: RESX.Buttons.ListView, visible: true, href: viewModel.listUrl },
          { text: RESX.Buttons.btnDelete, visible: viewModel.show.permissions.canDelete, onClick: () => { setDisplayDeleteModal(true); } },
        ]}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}